import { createStyles } from "@mantine/core"

export const useStyles = createStyles(
    (theme, { relative, noMarginOnButtons }: { relative: boolean; noMarginOnButtons?: boolean }) => ({
        backButton: {
            width: "40px",
            height: "40px",
            borderRadius: "50%",
            borderRight: 0,
            padding: "12px",
            color: theme.colors.gray[9],
            transition: "color .3s ease-in-out, background-color .3s ease-in-out",

            "&:hover": {
                color: theme.colors.violet[9],
                backgroundColor: theme.colors.violet[1],
            },
            "&:active": {
                transform: "none",
            },
        },
        rightSectionWrapper: {
            "& button": {
                marginLeft: noMarginOnButtons ? 0 : "1rem",
            },

            // Mobile responsiveness
            [theme.fn.smallerThan("xs")]: {
                flexShrink: 0,
                flexGrow: 0,

                "& button": {
                    marginLeft: noMarginOnButtons ? 0 : "10px",
                },
            },
        },
        title: {
            padding: 0,
            fontWeight: 500,
            fontSize: "1.25rem",
            lineHeight: "1.4",

            // Mobile responsiveness
            [theme.fn.smallerThan("xs")]: {
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                wordBreak: "break-word",
                overflow: "hidden",
            },
        },
        wrapper: {
            flex: 1,
            borderBottom: 0,
            height: "var(--header-height)",
            minHeight: "var(--header-height)",
            backgroundColor: "white",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 0.75rem",

            // Create a new stacking context, so the header renders over ANY element in the container, regardless of z-index!
            position: relative ? "relative" : "sticky",
            zIndex: 1,

            // Render the header below the Navbar
            top: 0,
            width: "100%",

            [theme.fn.largerThan("xs")]: {
                position: relative ? "relative" : "fixed",
                top: relative ? "unset" : "var(--navbar-height)",
                width: relative ? "unset" : "calc(100% - var(--side-navbar-width))",
                padding: "0rem 1.5rem",
            },
        },
        leftSection: {
            alignItems: "center",
            gap: "4px",
        },
    }),
)
